export const breakword = { // eslint-disable-line
  name: 'break-word',
  bind: el => {
    el.style.wordBreak = 'break-word'
    // IE FIX
    setTimeout(() => {
      el.style.removeProperty('-ms-word-break')
      const ua = window.navigator.userAgent
      const isIEFirefox = /MSIE|Trident|Firefox/.test(ua)
      if (isIEFirefox) {
        // IE specific code goes here
        el.style.removeProperty('display')
        el.style.removeProperty('max-height')
        el.style.removeProperty('line-height')
        el.style.display = 'block'
      }
    }, 10)
  }
}
